import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  Box,
  Chip,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

const FILTER_TYPE = [
  "All",
  "Technology",
  "Human Resource",
  "Customer Service",
  "Sales & Account Management",
  "Marketing",
];

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const JobListings = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");

  useEffect(() => {
    fetch(`${API_BASE_URL}/get_jobs.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.jobs)) {
          const parsedJobs = data.jobs.map((j) => ({
            job_id: j.job_id,
            title: j.title,
            location: j.location,
            department: j.department,
            customDepartment: j.custom_department || "",
            skills: j.skills ? JSON.parse(j.skills) : [],
            jd: j.jd,
            category: j.department || "Other",
            slug: j.slug || j.title?.toLowerCase().replace(/\s+/g, "-") || "",
            type: j.type || "",
          }));
          setJobs(parsedJobs);
        } else {
          setJobs([]);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch jobs:", err);
        setJobs([]);
      });
  }, []);

  const filteredJobs =
    selectedFilter === "All"
      ? jobs
      : jobs.filter((job) =>
          (job.category || "").toLowerCase().includes(selectedFilter.toLowerCase())
        );

  return (
    <Box sx={{ px: 0, py: 5 }}>
      <Container maxWidth="lg">
        <Box align="center">
          <Typography
            variant="h4"
            sx={{
              fontWeight: "500",
              fontSize: "2rem",
              color: "#000",
              textAlign: "center",
              mb: 2,
            }}
          >
            Open Roles at Across Assist
          </Typography>
        </Box>

        <Box
          align="center"
          maxWidth={"70%"}
          margin="auto"
          mt={{ xs: "1.1rem", sm: "1.1rem", md: "1.1rem", lg: "1.1rem" }}
        >
          We’re building a better way to work, fueled by transparency, trust,
          and technology that is a force for positive change for the hourly
          workforce
        </Box>

        <Box
          sx={{ overflowX: "auto", width: "100%" }}
          mt={{ xs: "1.1rem", sm: "1.1rem", md: "1.1rem", lg: "1.1rem" }}
        >
          <Stack
            my={2}
            spacing={2}
            direction="row"
            justifyContent="center"
            sx={{ minWidth: "max-content", px: 1 }}
          >
            {FILTER_TYPE.map((filter) => (
              <Chip
                key={filter}
                label={filter}
                onClick={() => setSelectedFilter(filter)}
                sx={{
                  fontWeight: 500,
                  px: 2,
                  py: 2.5,
                  borderRadius: "4px",
                  cursor: "pointer",
                  borderWidth: selectedFilter === filter ? 0 : 1,
                  borderStyle: "solid",
                  borderColor:
                    selectedFilter === filter ? "transparent" : "#ECECEC",
                  fontFamily: '"Poppins", serif',
                  color: selectedFilter === filter ? "#fff" : "black",
                  background:
                    selectedFilter === filter
                      ? "linear-gradient(93.14deg,#1E90FF, #63B8FF)"
                      : "#fff",
                  transition: "all 0.3s ease",
                  whiteSpace: "nowrap",
                }}
              />
            ))}
          </Stack>
        </Box>

        <Grid mt={3} container spacing={2} justifyContent="center">
          {filteredJobs?.map((job, idx) => (
            <Grid item key={idx} xs={12} md={4}>
              <Accordion
                onClick={() =>
                  navigate(
                    `/career-job-role?job-role=${job?.slug}&job-id=${job.job_id}`
                  )
                }
                sx={{
                  p: 2,
                  borderRadius: 2,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "#ECECEC",
                  backgroundColor: "white",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  width: {
                    xs: 280,
                    sm: 530,
                    md: 400,
                  },
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    gutterBottom
                    sx={{ fontFamily: '"Poppins",serif' }}
                  >
                    {(job?.category || "").toUpperCase()}
                  </Typography>

                  <Typography
                    variant="h6"
                    fontWeight={600}
                    gutterBottom
                    sx={{ fontFamily: '"Poppins",serif' }}
                  >
                    {job?.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontFamily: '"Poppins",serif' }}
                  >
                    {job?.location} / {job?.type}
                  </Typography>
                </Box>
              </Accordion>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default JobListings;